/**
 * ehr#278 / ehr#524: /?signature=edit opens your signature. Your signature lives on your own
 * profile (About > Signature; it was Forms Hub -> My Signature), so the link opens My profile
 * with the signature editor up. The profile page goes here when it is opened on its own; inside
 * the EHR it asks its frame instead. Closing the editor leaves you on the profile.
 */
export function parseSignatureParam(search: string): boolean {
  return new URLSearchParams(search).get('signature') === 'edit';
}

export function readSignatureParam(): boolean {
  return parseSignatureParam(window.location.search);
}

export function clearSignatureParam(): void {
  const url = new URL(window.location.href);
  if (!url.searchParams.has('signature')) return;
  url.searchParams.delete('signature');
  window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
}
